<template>
    <modal name="update_addition" height="auto" scrollable adaptive @before-open="beforeOpen">
        <app-card :title="$t('Update additional equipment')">
            <validation-observer v-slot="{ validate }" slim>
                <form @submit.prevent="update(validate)">
                    <addition-form :form="form"/>
                    <div v-if="form.dbname" class="row mt-3">
                        <div class="col">
                            <div class="float-left" style="position: relative">
                                <span class="mdi mdi-24px mdi-trash-can-outline trash-img" @click="destroyImg"/>
                                <img :src="`${envUrl}/additions/${form.dbname}`"
                                     width="160px"
                                     height="auto"
                                     class="img-thumbnail"/>
                                <p>{{ form.filename | truncate }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-md-7 offset-md-3 d-flex">
                            <app-button :loading="loading">
                                {{ $t('Update') }}
                            </app-button>
                            <app-button class="ml-2" type="outline-warning" native-type="button" @click="hide">
                                {{ $t('Cancel') }}
                            </app-button>
                        </div>
                    </div>
                </form>
            </validation-observer>
        </app-card>
    </modal>
</template>

<script>
import AdditionService from '@services/addition.service';
import AdditionForm from './components/Form';
import {mapGetters} from 'vuex';

export default {
    data() {
        return {
            form: {
                img: {},
                dbname: null,
                filename: null,
            },
            loading: false,
            addition_id: null
        };
    },
    computed: {
        ...mapGetters(['envUrl'])
    },
    methods: {
        destroyImg() {
            AdditionService.destroyImg(this.addition_id).then(res => {
                this.form.dbname = null;
                this.form.filename = null;
                this.$emit('setAddition', res);
            });
        },
        update(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    AdditionService.update(this.addition_id, this.form).then(res => {
                        this.$toastr.s(this.$t('Updated'));
                        this.loading = false;
                        this.hide();
                        this.$emit('setAddition', res);
                    });
                }
            });
        },
        beforeOpen(event) {
            const addition = event.params.addition;
            if (addition) {
                this.form.name = Object.assign({}, addition.name);
                this.form.comments = Object.assign({}, addition.comments);
                this.form.dbname = addition.dbname;
                this.form.filename = addition.filename;
                this.addition_id = addition.id;
            }
        },
        hide() {
            this.$modal.hide('update_addition');
        }
    },
    components: {
        AdditionForm
    }
};
</script>
